export default "__VITE_ASSET__vZE9lIow__"